/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".leaguinvSec[_ngcontent-%COMP%]{position:relative;min-height:45px;padding:35px 14px 0 97px!important}.leaguinvSec[_ngcontent-%COMP%]   .leaguinvImg[_ngcontent-%COMP%]{position:absolute;left:20px;top:18px;width:65px;height:65px;background-repeat:no-repeat;background-position:center;background-size:cover;border-radius:50%}"];
export { styles as styles };
